import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/consultation/register/page.tsx");
